










































import {Component, Prop, Vue} from "vue-property-decorator";
import DetailLading from "@/modules/ladings/Detail/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import LadingPrintA6 from "@/modules/ladings/Print/LabelA6/index.vue";

@Component({
    name: "PrintLading",
    components: {LadingPrintA6, LadingPrintBill, DetailLadingPrint, DetailLading}
})
export default class extends Vue {
    @Prop({required: true}) readonly ladingIds!: string;
    @Prop({default: 'print-bill', required: false}) readonly idPrintBill!: string;
    @Prop({default: 'print-a6', required: false}) readonly idPrintA6!: string;
    visible = false;
    visibleChooseBill = false;
    hideFee = true;

    printObj: Options = {
        id: this.idPrintBill,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    printA6Obj: Options = {
        id: this.idPrintA6,
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    showChoosePrintLading() {
        (this.$refs.btnShowChoosePrintLading as any).$el.click();
    }

    printBill() {
        this.$print(this.printObj);
    }

    printA6() {
        this.$print(this.printA6Obj);
    }

    onChangeHideFee(e) {
        this.hideFee = e.target.checked;
    }
}
